<section class="px-3 py-3 border-bottom"
         aria-labelledby="device-health-overview-heading">
  <h2 id="device-health-overview-heading"
      class="h5 mb-3">Device health overview — {{ location().displayName }}</h2>

  @if (deviceCount() === 0) {
    <p class="mb-0">No devices at this location.</p>
  } @else {
    <ng-content></ng-content>
  }
</section>